import React, { useState, useCallback, useEffect } from "react";
//eslint-disable-next-line
import { useNavigate, Link } from "react-router-dom";

import CustomPopup from "../common/CustomPopup";
import IpConfirmation from "../common/IpConfirmation";
import { deactivateUser, updateEmailPreferences, getCurrentUser } from "../api";

function Profile({ currentUser }) {
  const [showPopup, setShowPopup] = useState(false);
  const [cancelSubPopup, setCancelSubPopup] = useState(false);
  const [error, setError] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [reloadPage, setReloadPage] = useState(false); //eslint-disable-line
  const [emailPreferences, setEmailPreferences] = useState({
    email: currentUser?.emailId || "",
    hourlyAlerts: currentUser?.hourlyAlerts || false,
    dailySummary: currentUser?.dailySummary || false,
  });

  const [tempPreferences, setTempPreferences] = useState({
    hourlyAlerts: currentUser?.hourlyAlerts || false,
    dailySummary: currentUser?.dailySummary || false,
  });

  useEffect(() => {
    if (currentUser?.emailId) {
      setEmailPreferences((prev) => ({
        ...prev,
        email: currentUser.emailId,
        hourlyAlerts: currentUser.hourlyAlerts || false,
        dailySummary: currentUser.dailySummary || false,
      }));
      setTempPreferences({
        hourlyAlerts: currentUser.hourlyAlerts || false,
        dailySummary: currentUser.dailySummary || false,
      });
    }
  }, [currentUser]);

  function pascalCase(str) {
    if (str !== undefined) {
      return str
        .split(" ")
        .reduce(
          (s, c) => s + "" + (c.charAt(0).toUpperCase() + c.slice(1) + " "),
          "",
        );
    }
    return null;
  }

  const updateStatus = useCallback((state) => {
    if (state) {
      // window.location.reload();
      setReloadPage(true); //suggested as per coderabbit
    }
    setShowPopup(false);
  }, []);

  const notHomeNetwork = useCallback(() => {
    setTimeout(() => {
      setShowPopup(false);
    }, 15000);
  }, []);

  const cancelSubscription = () => {
    deactivateUser()
      .then((response) => {
        if (response) {
          window.location.reload();
        }
        setCancelSubPopup(false);
      })
      .catch((error) => {
        setError(error.message);
      });
  };
  const closeCancelSubscription = () => {
    setCancelSubPopup(false);
  };

  // PM June 17th 2025. Not sure how this one got added.
  //  const handleDeactivate = () => {
  //    deactivateUser()
  //      .then((response) => {
  //        if (response) {
  //          window.location.reload();
  //        }
  //      })
  //      .catch((error) => {
  //        setError(error.message);
  //      });
  //  };

  const CancelSubscriptionLayout = () => {
    return (
      <div>
        <CustomPopup show={true} onClose={closeCancelSubscription}>
          <div>
            <div>
              <h1 className="heading-52">Alert</h1>
              <div className="text-block-161">
                Are you sure you want to cancel the subscription
              </div>
            </div>
            <div className="div-block-48-confirm">
              <button
                type="button"
                onClick={cancelSubscription}
                className="button-21-confirm w-button"
              >
                Yes
              </button>
              <button
                type="button"
                onClick={closeCancelSubscription}
                className="button-20-confirm w-button"
              >
                No
              </button>
              {error && (
                <div className="w-form-fail">
                  Oops! Something went wrong while submitting.
                </div>
              )}
            </div>
          </div>
        </CustomPopup>
      </div>
    );
  };

  const handleEmailPreferenceChange = (preference) => {
    setTempPreferences((prev) => ({
      ...prev,
      [preference]: !prev[preference],
    }));
  };

  const updateNotificationPreferences = async () => {
    try {
      const updatedPreferences = {
        ...emailPreferences,
        ...tempPreferences,
      };

      await updateEmailPreferences(updatedPreferences);
      setEmailPreferences(updatedPreferences);
      setTempPreferences({
        hourlyAlerts: updatedPreferences.hourlyAlerts,
        dailySummary: updatedPreferences.dailySummary,
      });
      setSuccessMessage("Notification preferences updated successfully");
      setError(false);
    } catch (err) {
      setError(
        "Failed to update notification preferences. Please try again later.",
      );
      setSuccessMessage("");
    }
  };

  return (
    <div>
      {" "}
      <div className="customer-account-information-section wf-section">
        <div className="container-2 w-container">
          <h1 className="heading-44">Your Account Information</h1>
          <div className="columns-53 w-row">
            <div className="column-110 w-col w-col-6 w-col-tiny-tiny-stack">
              <div className="div-block-44">
                <h3 className="heading-45">
                  <strong className="bold-text-93">
                    {" "}
                    Subscription Package:{" "}
                  </strong>
                  <div className="profile-vals">
                    {" "}
                    {currentUser.productLabel ?? "N/A"}{" "}
                  </div>
                </h3>
                <h3 className="heading-46">
                  <strong className="bold-text-93">
                    Registered IP Address:{" "}
                  </strong>
                  <div className="profile-vals">
                    {currentUser.serviceIpAddress ?? "N/A"}
                  </div>
                </h3>
                <h3 className="heading-46">
                  <strong className="bold-text-93">Public IP Address: </strong>
                  <div className="profile-vals">
                    {currentUser.publicIpAddress ?? "N/A"}
                  </div>
                </h3>
                <h3 className="heading-47">
                  <strong className="bold-text-93">Subscription Plan: </strong>
                  <div className="profile-vals">
                    {pascalCase(currentUser.subscriptionPlan) ?? "N/A"}
                  </div>
                </h3>
              </div>
            </div>
            <div className="column-111 w-col w-col-6 w-col-tiny-tiny-stack">
              <div className="div-block-46">
                <h3 className="heading-48">Account Actions</h3>
                <div className="button-container">
                  <button
                    className="button-26-new w-button"
                    onClick={(e) => setCancelSubPopup(true)}
                  >
                    Cancel Subscription
                  </button>
                </div>
                {currentUser.serviceIpAddress !==
                  currentUser.publicIpAddress && (
                  <div className="div-block-46-reconnect">
                    <h3 className="heading-48">
                      Click on 'Reconnect' to update your registered IP Address{" "}
                    </h3>
                    <div className="button-container">
                      <button
                        className="button-26-new w-button"
                        onClick={(e) => setShowPopup(true)}
                      >
                        Reconnect
                      </button>
                    </div>
                  </div>
                )}
                <div>
                  <h3 className="heading-48">Email Notifications</h3>
                  <div className="notification-option">
                    <label className="notification-label">
                      <div
                        style={{
                          display: "flex",
                          alignItems: "left",
                          gap: "5px",
                        }}
                      >
                        <strong className="bold-text-93">Email: </strong>
                        <div className="profile-vals">
                          {emailPreferences.email || "Not set"}
                        </div>
                      </div>
                    </label>
                  </div>
                  <div className="notification-option">
                    <label className="notification-label">
                      <input
                        type="checkbox"
                        checked={tempPreferences.hourlyAlerts}
                        onChange={() =>
                          handleEmailPreferenceChange("hourlyAlerts")
                        }
                        className="notification-checkbox"
                      />
                      Hourly Critical Alerts
                    </label>
                    <p className="notification-description">
                      Receive immediate notifications for critical security
                      alerts
                    </p>
                  </div>
                  <div className="notification-option">
                    <label className="notification-label">
                      <input
                        type="checkbox"
                        checked={tempPreferences.dailySummary}
                        onChange={() =>
                          handleEmailPreferenceChange("dailySummary")
                        }
                        className="notification-checkbox"
                      />
                      Daily Summary
                    </label>
                    <p className="notification-description">
                      Get a daily summary of your security status and blocked
                      threats
                    </p>
                  </div>
                  <button
                    className="button-26-new w-button"
                    onClick={updateNotificationPreferences}
                    style={{ marginTop: "20px" }}
                  >
                    Update Notification Preferences
                  </button>
                  {successMessage && (
                    <div style={{ color: "green", marginTop: "10px" }}>
                      {successMessage}
                    </div>
                  )}
                  {error && (
                    <div style={{ color: "red", marginTop: "10px" }}>
                      {error}
                    </div>
                  )}
                </div>
              </div>
            </div>
            {showPopup && (
              <IpConfirmation
                onUpdateStatus={updateStatus}
                onNotConnected={notHomeNetwork}
              />
            )}
            {cancelSubPopup && <CancelSubscriptionLayout />}
          </div>
          <div className="columns-57 w-row">
            <div className="column-117 w-col w-col-6">
              <a href="https://www.getkavalan.com/tos" className="link-29">
                Terms of Service
              </a>
            </div>
            <div className="w-col w-col-6">
              <a href="https://www.getkavalan.com/privacy" className="link-28">
                Privacy Policy
              </a>
            </div>
          </div>
          <Link to="/dashboard" className="button-7 w-button">
            Back to Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Profile;
